<template>
    <div>
        <mLayout ref="mLayout"></mLayout>
        <ul>
            <li @click.stop="handleClickLink(item,key)" v-for="(item,key) in tagList" :key="key">
                <p v-text="item.title"></p>
                <span @click.stop="handleClickDel(item,key)"><i class="iconfont icon-guanbi"></i></span>
            </li>
        </ul>
    </div>
</template>

<script>
import mLayout from "../../mLayout/index";
import {mapState} from 'vuex'

export default {
    name: "TagRouterList",
    components: {
        mLayout
    },
    props: {},
    data() {
        return {}
    },
    computed: {
        ...mapState(['tagList'])
    },
    created() {

    },
    mounted() {

    },
    methods: {
        handleClickDel(item, key) {
            let tagList = this.tagList;
            tagList.splice(key, 1);
            this.$store.dispatch("saveTagInfo", tagList);
        },
        handleClickLink(item, index) {
            this.$emit('handleClickRetract',true)
            this.$router.push({
                name: item.name,
                params: {
                    noCache: true,
                    index,
                },
                query: item.query,
            })
        },


    }
}
</script>

<style lang="scss" scoped>
ul {
    width: 100%;
    height: calc(100vh - 80px);
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;

    li {
        height: 38px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.08);
        padding: 0 12px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;

        p {
            flex: 1;
            font-size: 14px;
            text-align: left;
            color: rgba(255, 255, 255, 0.9);
        }

        span {
            width: 22px;
            min-width: 22px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            opacity: 1;
            border-radius: 4px;

            &:hover {
                background: rgba(255, 255, 255, 0.16);
            }

            i {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.8);
                vertical-align: super;
            }
        }
    }
}
</style>
